import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import CommentarySection
  from 'Components/ComponentLibrary/Organisms/AccountPerformanceCommentaryCard/Sections/CommentarySection';
import NonHighlightHeader
  from 'Components/ComponentLibrary/Organisms/AccountPerformanceCommentaryCard/Sections/NonHighlightHeader';
import { Button } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import { Collapse } from '@mui/material';
import PerformanceSection
  from 'Components/ComponentLibrary/Organisms/AccountPerformanceCommentaryCard/Sections/PerformanceSection';
import { getSectionCardStyle } from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/styles';
import useManagedAccountPageEventLogger
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/managedAccountPage.eventLogging';
import useMobileLayout from 'Hooks/useMobileLayout';
import DateRangeSection
  from 'Components/ComponentLibrary/Organisms/AccountPerformanceCommentaryCard/Sections/DateRangeSection';

const styles = (theme) => ({
  root: {
    ...getSectionCardStyle({ theme }),
    display: 'flex',
    flexDirection: 'column',
    rowGap: theme.spacing(1),
  },
  mobileRevealSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
});

const getButtonText = (show) => {
  if (show) {
    return 'Show Less';
  }
  return 'See Facet\'s Take';
};

const NonHighlightedCommentaryCard = ({
  className,
  classes,
  label,
  startDate,
  endDate,
  performance,
  benchmark,
  commentary,
  lastUpdated,
  chartData,
  showBenchmark,
  onClickDateRange,
}) => {
  const isMobile = useMobileLayout();

  const [show, setShow] = React.useState(false);
  const [buttonText, setButtonText] = React.useState(getButtonText(show));

  const { logCommentaryEvent } = useManagedAccountPageEventLogger();

  const handleOnClick = () => {
    logCommentaryEvent(`${!show ? 'Show' : 'Hide'} commentary`, {
      name: label,
    });
    setButtonText(getButtonText(!show));
    setShow(!show);
  };

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <NonHighlightHeader label={label} startDate={startDate} endDate={endDate} chartData={chartData} onClickDateRange={onClickDateRange} />
      {!isMobile && <PerformanceSection benchmark={benchmark} performance={performance} showBenchmark={showBenchmark} />}
      <Box>
        <Collapse in={show}>
          <Box className={classes.mobileRevealSection}>
            {isMobile && <>
              <DateRangeSection startDate={startDate} endDate={endDate} onClickDateRange={onClickDateRange} />
              <PerformanceSection benchmark={benchmark} performance={performance} showBenchmark={showBenchmark} />
            </>}
            <CommentarySection commentary={commentary} lastUpdated={lastUpdated} />
          </Box>
        </Collapse>
        <Button variant={'underlined'} padding={'none'} color={'primary'} onClick={handleOnClick}>{buttonText}</Button>
      </Box>
    </Box>
  );
};

NonHighlightedCommentaryCard.defaultProps = {
  className: '',
  chartData: undefined,
  showBenchmark: true,
  onClickDateRange: undefined,
};

NonHighlightedCommentaryCard.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  performance: PropTypes.string.isRequired,
  benchmark: PropTypes.string.isRequired,
  commentary: PropTypes.string.isRequired,
  chartData: PropTypes.array,
  lastUpdated: PropTypes.string.isRequired,
  showBenchmark: PropTypes.bool,
  onClickDateRange: PropTypes.func,
};

export default withStyles(styles)(NonHighlightedCommentaryCard);
